export default {
	sec_01: {
		title: {
			one: 'A safe and fun way to',
			two: 'remittance ',
			three: 'online',
		},
		desc: {
			one: "It's a simple way to quickly remit money to family and",
			two: 'friends from almost anywhere in the world.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_04: {
		title: 'Get the most out of all transfers',
		cards: {
			one: {
				title: 'Two-way messages',
				description: {
					one: 'Exchange messages to check if the payment ',
					two: 'is correctly made between friends.',
				},
			},
			two: {
				title: 'Free Options',
				description: {
					one: 'After you use the JP WORLD Pay point card ',
					two: "and check it's balance, you can remit money",
					three: 'online from overseas.',
				},
			},
			three: {
				title: 'Quick Access',
				description: {
					one: 'The recipient can get the money ',
					two: 'without delay when remitting ',
					three: 'cryptocurrency.',
				},
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'Year-Round',
				two: 'Monitoring',
			},
			desc: {
				one: 'With encryption technology, we do our best to',
				two: 'ensure that your transfer is safe.',
			},
		},
		two: {
			title: {
				one: 'Transfer Worldwide',
			},
			desc: {
				one: 'Transfer money to your recipient anywhere',
				two: 'in the world with JP WORLD Pay.',
				three:
					'Transfer money online to friends and family anywhere in the world',
			},
		},
	},
	sec_09: {
		title: {
			one: '0 JPYS',
			two: 'Transaction fee in JP WORLD Pay',
		},
		one: {
			desc: {
				one: 'When withdrawing from wallets from other banks, ',
				two: '0% if money is sent from JP WORLD PAY balance.',
			},
		},
	},
};
